import { render } from "./SuppliersIndex.vue?vue&type=template&id=21d216de"
import script from "./SuppliersIndex.vue?vue&type=script&lang=js"
export * from "./SuppliersIndex.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__